import { render } from "./TradingSteps.vue?vue&type=template&id=c33b970a&scoped=true"
import script from "./TradingSteps.vue?vue&type=script&lang=js"
export * from "./TradingSteps.vue?vue&type=script&lang=js"

import "./TradingSteps.vue?vue&type=style&index=0&id=c33b970a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33b970a"]])

export default __exports__